import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Screen } from '../../components/Screen/Screen';
import { ScreenHeader } from '../../components/ScreenHeader/ScreenHeader';
import { Button } from '../../components/Button/Button';
import { copy } from '../../constants';
import { useOnboardingStore } from '../../store/onboarding';
import './Welcome.css';

export const Welcome: React.FC = () => {
  const navigate = useNavigate();
  const { setStep } = useOnboardingStore();

  const handleStart = () => {
    setStep(2);
    navigate('/for-whom');
  };

  return (
    <Screen className="welcome">
      <div className="welcome__content">
        <ScreenHeader
          title={copy.welcome.title}
          subtitle={copy.welcome.subtitle}
        />
        
        <div className="welcome__illustration">
          {/* Placeholder for calming illustration */}
          <div className="welcome__icon">💙</div>
        </div>
      </div>
      
      <div className="welcome__actions">
        <Button
          variant="primary"
          size="large"
          fullWidth
          onClick={handleStart}
        >
          {copy.welcome.button}
        </Button>
      </div>
    </Screen>
  );
};
